function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { StyledYouTubeVideoComponent } from "./youtube-video-component.scss";
import classnames from "classnames";
import { PureComponent } from "react";
import Youtube from "react-youtube";
import { withGenericConfig } from "contexts/generic-config-context";
import { trackEvent } from "/services/bigbrain-service";
import { isInClientAndCookieCategoryNotApproved } from "services/cookies-service";
import { COOKIE_CATEGORIES } from "constants/cookies-categories";
import { YOUTUBE_VIDEO_STARTED, YOUTUBE_VIDEO_ENDED } from "/constants/bigbrain-event-types";
const DEFAULT_PLAYER_VARS = {
    modestbranding: 1,
    controls: 1,
    rel: 0,
    frameBorder: 0,
    showinfo: 1,
    playsinline: 0
};
const DEFAULT_OPTS = {
    playerVars: DEFAULT_PLAYER_VARS
};
export const YOUTUBE_EMBEDED_HOST = "https://www.youtube.com";
export const YOUTUBE_EMBEDED_NOCOOKIE_HOST = "https://www.youtube-nocookie.com";
class YouTubeVideoComponent extends PureComponent {
    onReady(event) {
        const { onReady, playing } = this.props;
        this._player = event.target;
        this.toggleMute();
        this.setVolume();
        if (playing) {
            // We want do to it only if playing = true so we don't pause the video.
            this.togglePlay();
        }
        onReady(event);
    }
    componentDidUpdate(prevProps) {
        if (this.props.muted !== prevProps.muted) {
            this.toggleMute();
        }
        if (this.props.playing !== prevProps.playing) {
            this.togglePlay();
        }
        if (this.props.volume !== prevProps.volume) {
            this.setVolume();
        }
    }
    toggleMute() {
        const { muted } = this.props;
        if (!this._player) {
            return;
        }
        if (muted) {
            this._player.mute();
        } else {
            this._player.unMute();
        }
    }
    togglePlay() {
        const { playing } = this.props;
        if (!this._player) {
            return;
        }
        if (playing) {
            this._player.playVideo();
        } else {
            this._player.pauseVideo();
        }
    }
    setVolume() {
        const { volume } = this.props;
        if (!this._player || volume === null) {
            return;
        }
        this._player.setVolume(volume);
    }
    getYoutubeHost() {
        return isInClientAndCookieCategoryNotApproved(COOKIE_CATEGORIES.MARKETING) //GDPR relevant - in other countries Marketing category is always approved
         ? YOUTUBE_EMBEDED_NOCOOKIE_HOST : YOUTUBE_EMBEDED_HOST;
    }
    generateOpts() {
        const { opts } = this.props;
        return _object_spread_props(_object_spread({}, opts), {
            host: this.getYoutubeHost()
        });
    }
    render() {
        const { videoId, background, showShadow } = this.props;
        return /*#__PURE__*/ _jsx(StyledYouTubeVideoComponent, {
            className: "youtube-video-component",
            children: /*#__PURE__*/ _jsx("div", {
                className: classnames(`video-container`, {
                    [background]: background
                }),
                children: /*#__PURE__*/ _jsx("div", {
                    className: classnames("content", {
                        "with-shadow": showShadow
                    }),
                    children: /*#__PURE__*/ _jsx(Youtube, _object_spread_props(_object_spread({}, this.props), {
                        videoId: videoId,
                        onReady: this.onReady,
                        opts: this.generateOpts(),
                        onEnd: this.onEnd,
                        onPlay: this.onPlay
                    }))
                })
            })
        });
    }
    constructor(props){
        super(props);
        _define_property(this, "onPlay", (event)=>{
            const { onPlay, videoId } = this.props;
            trackEvent(YOUTUBE_VIDEO_STARTED, {
                kind: videoId
            });
            if (onPlay) onPlay(event);
        });
        _define_property(this, "onEnd", (event)=>{
            const { onEnd, videoId } = this.props;
            trackEvent(YOUTUBE_VIDEO_ENDED, {
                kind: videoId
            });
            if (onEnd) onEnd(event);
        });
        this.onReady = this.onReady.bind(this);
        this._player = null;
    }
}
YouTubeVideoComponent.defaultProps = {
    playing: false,
    volume: null,
    muted: false,
    onReady: ()=>{},
    onEnd: ()=>{},
    onPlay: ()=>{},
    opts: DEFAULT_OPTS
};
export default withGenericConfig(YouTubeVideoComponent);
